export default __webpack_public_path__ + "static/media/location_helsinki.2f883c8d.jpg";